import { Dialog } from '@/components/Dialog';
import { Button } from '@/pages/Home/components/SongDetail';
import { deleteAudio } from '@/service/audioList';
import { useAudioListStore } from '@/state/audio-list-store';
import React from 'react';
import { useRefreshData } from './useRefreshData';

export const useDeleteTrack = ({ id }: { id: string }) => {
  const { refreshAudioInList, refreshCatalogOverview, refreshFolders } = useRefreshData();
  const { setSelectedInfo, selectedInfo } = useAudioListStore();
  const delAudioAndRefresh = async () => {
    await deleteAudio({
      id,
    });
    refreshCatalogOverview();
    refreshAudioInList({ id });
    refreshFolders();

    if (selectedInfo?.id === id) {
      setSelectedInfo(null);
    }
  };
  const showDeleteDialog = () => {
    Dialog.info({
      closeClassName: 'left-auto right-4 !p-0 rounded-[4px] ',
      dialogContentClassName: 'bg-jen-content-primary-contrast',
      title: 'Archive Track',
      contentJSX: ({ onClose }) => {
        return (
          <div className=" p-jen-spacing-16 text-jen-content-secondary">
            <div className=" text-jen-size-heading-05">Are you sure you want to archive this track?</div>
            <Button
              onClick={async () => {
                await delAudioAndRefresh();
                onClose();
              }}
              className="text-jen-content-primary-contrast bg-jen-interactive-primary mt-jen-spacing-32 h-[40px]"
              text="Archive"
            />
            <Button
              onClick={onClose}
              className=" bg-jen-interactive-accent text-jen-interactive-primary mt-jen-spacing-8 h-[40px]"
              text="Cancel"
            />
          </div>
        );
      },
    });
  };
  return { showDeleteDialog, delAudioAndRefresh };
};
